/* Bike make & model box shown under qualifying cart items. Saves into the cart (order) note. */
if (!customElements.get('bike-note-field')) {
  class BikeNoteField extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.status = this.querySelector('[data-bike-note-status]');
      this.prefix = this.dataset.prefix || 'Bike make & model:';
      if (!this.input) return;

      var existing = this.findLine(this.dataset.note || '');
      if (existing && !this.input.value) this.input.value = existing;

      this.timer = null;
      this.onInput = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.save(), 700);
      };
      this.onChange = () => {
        clearTimeout(this.timer);
        this.save();
      };
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    findLine(note) {
      var prefix = this.prefix.toLowerCase();
      var line = note.split(/\r?\n/).find((l) => l.trim().toLowerCase().indexOf(prefix) === 0);
      return line ? line.trim().slice(this.prefix.length).trim() : '';
    }

    buildNote(note, value) {
      var prefix = this.prefix.toLowerCase();
      var lines = note.split(/\r?\n/).filter((l) => l.trim() && l.trim().toLowerCase().indexOf(prefix) !== 0);
      if (value) lines.unshift(this.prefix + ' ' + value);
      return lines.join('\n');
    }

    save() {
      var value = this.input.value.trim();
      if (value === this.lastSaved) return;
      this.lastSaved = value;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      /* Read the latest note first so other notes (Special Instructions) are kept. */
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then((res) => res.json())
        .then((cart) => {
          var note = this.buildNote(cart.note || '', value);
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            keepalive: true,
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: note })
          }).then(() => note);
        })
        .then((note) => {
          this.dataset.note = note;
          document.querySelectorAll('bike-note-field').forEach((el) => { el.dataset.note = note; });
          var pageNote = document.getElementById('cart-note');
          if (pageNote && document.activeElement !== pageNote) pageNote.value = note;
          if (this.status && value) {
            this.status.hidden = false;
            clearTimeout(this.statusTimer);
            this.statusTimer = setTimeout(() => { this.status.hidden = true; }, 2500);
          }
        })
        .catch(() => { this.lastSaved = null; });
    }
  }

  customElements.define('bike-note-field', BikeNoteField);
}
